module.exports = __webpack_public_path__ + "img/dive-report20.1549ced8.png";